export default __webpack_public_path__ + "static/media/NO.5c636675.svg";